import { type Stylesheet } from "@/cms/sanity.types";
import { stegaClean } from "next-sanity";
import { type CSSProperties } from "react";

export function theme(
  theme?: Partial<Stylesheet> | null,
): CSSProperties | undefined {
  if (!theme) return undefined;
  const styles = Object.values(stegaClean(theme)).reduce<CSSProperties>(
    (acc, cur) => {
      if (cur && typeof cur === "object" && "tokenType" in cur && cur.token) {
        const { value } = cur;
        if (!value) return acc;
        return {
          ...acc,
          [cur.token]: value,
        };
      }
      return acc;
    },
    {},
  );
  return styles;
}
